import type { BundleOfferDto } from '../bundles/bundleOffers.schema';
import z from 'zod';
import { BundleOfferDtoSchema } from '../bundles/bundleOffers.schema';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';

export const fastShopApi = {
  parseArray: (data: unknown) => z.array(BundleOfferDtoSchema).parse(data),

  async getMeFastBundleOffers() {
    const response = await httpClient.get<Array<BundleOfferDto>>(ENDPOINTS.fastShop.meFastBundleOffers);

    return fastShopApi.parseArray(response);
  },
};
